import { render, staticRenderFns } from "./ContactOptions.vue?vue&type=template&id=63255460"
import script from "./ContactOptions.vue?vue&type=script&lang=tsx"
export * from "./ContactOptions.vue?vue&type=script&lang=tsx"
import style0 from "./ContactOptions.vue?vue&type=style&index=0&id=63255460&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports